import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { CreateAgentRequest, DeleteAgentRequest, GetAgentRequest, GetAgentsRequest, UpdateAgentRequest } from "./api";

type Props = {
    onSuccess?: (data: any) => void;
    onError?: (error: any) => void;
}

const useCreateAgent = (props?: Props) => {
    const queryClient = useQueryClient();
    const {mutate, isLoading, isError, error} = useMutation(CreateAgentRequest, {
        onSuccess: (data: any) => {
            queryClient.invalidateQueries(['agents']);
            queryClient.invalidateQueries(['agents', `${data.id}`]);
            props?.onSuccess && props.onSuccess(data);
        },
        onError: props?.onError,
    });

    return {mutate, isLoading, isError, error};
};

const useUpdateAgent = (props?: Props) => {
    const queryClient = useQueryClient();
    const {mutate, isLoading, isError, error} = useMutation(UpdateAgentRequest, {
        onSuccess: (data: any) => {
            queryClient.invalidateQueries(['agents']);
            queryClient.invalidateQueries(['agents', `${data.id}`]);
            props?.onSuccess && props.onSuccess(data);
        },
        onError: props?.onError,
    });

    return {mutate, isLoading, isError, error};
};

const useGetAgent = (agentId: number, props?: Props) => {
    const {data, isLoading, isError} = useQuery<any>(['agents', `${agentId}`], () => GetAgentRequest(agentId), {
        onSuccess: props?.onSuccess,
        onError: props?.onError,
    });

    return {data, isLoading, isError};
};

const useDeleteAgent = (props?: Props) => {
    const queryClient = useQueryClient();
    const {mutate, isLoading, isError, error} = useMutation(DeleteAgentRequest, {
        onSuccess: (data: any) => {
            queryClient.invalidateQueries(['agents']);
            queryClient.invalidateQueries(['agents', `${data.id}`]);
            props?.onSuccess && props.onSuccess(data);
        },
        onError: props?.onError,
    });

    return {mutate, isLoading, isError, error};
};

const useGetAgents = (props?: Props) => {
    const {data, isLoading, isError} = useQuery<any>(['agents'], GetAgentsRequest, {
        onSuccess: props?.onSuccess,
        onError: props?.onError,
    });

    return {data, isLoading, isError};
};

export { useCreateAgent, useUpdateAgent, useGetAgent, useDeleteAgent, useGetAgents };